export const USER_PREFERENCE = {
    SystemTypeId: 'SystemTypeId'
};